import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  boxTop: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    height: '40px' // Match the height of small text fields
  },
  filtersTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2)
  }
}));

export default useStyles;
